import { type ReactNode } from "react";

import {
  Accordion,
  AccordionVariant,
} from "@vega-core/components/Accordion/Accordion";

import { FAQList, type FAQListProps } from "./FAQList";

type Props = FAQListProps & {
  enableHashHighlight?: boolean;
  title: ReactNode;
  description?: ReactNode;
  value: string;
  isOpen?: boolean;
  onToggle?: (isOpen: boolean) => void;
};

export function FAQNested({
  title,
  description,
  value,
  enableHashHighlight,
  isOpen,
  onToggle,
  ...props
}: Props) {
  const isControlled = isOpen !== undefined;
  const handleValueChange = (nextValue: string) =>
    onToggle?.(nextValue === value);

  return (
    <Accordion
      collapsible
      items={[
        {
          title,
          content: (
            <>
              {description}
              <FAQList
                {...props}
                enableHashHighlight={enableHashHighlight}
                isFull
              />
            </>
          ),
          value,
        },
      ]}
      type="single"
      variant={AccordionVariant.FAQ}
      {...(isControlled
        ? {
            value: isOpen ? value : "",
            onValueChange: handleValueChange,
          }
        : {})}
    />
  );
}
